export const pxToRem = (px, base = 16) => `${px / base}rem`;